import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    SimpleGrid,
    useBreakpointValue,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getPath} from '../../utils/custom-utils'

const FormatedContentAsset = (props) => {
    const {site, locale} = useMultiSite()
    const isDesktop = useBreakpointValue({base: false, md: false, lg: true})
    const {content: directContent} = props
    const htmlContent = directContent

    const convertHtmltoJson = (jsonData) => {
        if (typeof window !== 'undefined') {
            const parser = new DOMParser()
            const doc = parser.parseFromString(jsonData, 'text/html')
            const mainHeading = doc.querySelector('h4.text-uppercase')?.innerText || ''
            const menuLists = doc.querySelectorAll('.menu-list')
            const copyrightElement = doc.querySelector('.copyright')

            const categories = Array.from(menuLists).map((item) => {
                const headingElement = item.querySelector('p.heading')
                const heading = headingElement?.innerText || ''

                const category = Array.from(item.querySelectorAll('a')).map((link) => {
                    const path = getPath(link.getAttribute('href'), site, locale)
                    return {
                        subCategory: link?.innerText || '',
                        link: path?.url || '',
                        isExternalURL: path?.isExternalURL || '',
                        externalClassName: link?.getAttribute('data-class'),
                        target: link?.getAttribute('target') || ''
                    }
                })

                return {heading, category}
            })

            let copyright = {
                text: '',
                links: []
            }

            if (copyrightElement) {
                const paragraph = copyrightElement.querySelector('p')
                const spans = copyrightElement.querySelectorAll('span a')

                copyright.text = paragraph?.innerText || ''
                copyright.links = Array.from(spans).map((a) => ({
                    label: a.innerText,
                    href: a.getAttribute('href')
                }))
            }

            return {
                mainHeading,
                categories,
                copyright
            }
        }
        return {}
    }

    const jsonData = convertHtmltoJson(htmlContent)
    const styles = useMultiStyleConfig('FormatedContentAsset')
    const [isHydrated, setIsHydrated] = useState(false)

    useEffect(() => {
        setIsHydrated(true)
    }, [])

    return (
        <Box className={'content-asset'} padding={{base: '0', lg: '0 12.5px'}}>
            {isHydrated && jsonData && jsonData.categories && jsonData.categories.length > 0 && (
                <SimpleGrid
                    columns={{base: 2, sm: 4}}
                    direction={isDesktop ? 'row' : 'column'}
                    width={'100%'}
                    lineHeight={isDesktop ? '2.5rem' : '1.5rem'}
                    {...styles.contentAssetBody}
                >
                    {jsonData.categories.map((section, index) => (
                        <Box key={index} minW="150px" flex="1" pb={4} px={4}>
                            <Box mb={2} {...styles.contentAssetHeading}>
                                {section.heading}
                            </Box>
                            {section.category.map((item, idx) => (
                                <Box key={idx} {...styles.contentAssetContent}>
                                    {item?.isExternalURL ? (
                                        <a
                                            href={item.link}
                                            className={item?.externalClassName}
                                            target={item?.target}
                                            rel="noopener noreferrer"
                                        >
                                            {item.subCategory}
                                        </a>
                                    ) : item?.link ? (
                                        <Link
                                            to={item.link}
                                            className={item?.externalClassName}
                                            target={item?.target}
                                        >
                                            {item.subCategory}
                                        </Link>
                                    ) : (
                                        <span className={item?.externalClassName}>
                                            {item.subCategory}
                                        </span>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    ))}
                </SimpleGrid>
            )}
        </Box>
    )
}
FormatedContentAsset.propTypes = {
    id: PropTypes.string,
    locale: PropTypes.string,
    content: PropTypes.string
}
export default FormatedContentAsset
